import { compact, concat, filter, find } from "lodash";
import { getRandIntExclusive } from "./numberUtils";

export const getWrapIndex = (i, increment, length) => {
  const finalIncrement = increment % length;
  let newI = i + finalIncrement;

  if (newI >= length) {
    newI = newI - length;
  } else if (newI < 0) {
    newI = length + newI;
  }

  return newI;
};

export const getWrap = (arr, i, increment = 1) => {
  return arr[getWrapIndex(i, increment, arr.length)];
};

export const getRandIndex = (arr) => getRandIntExclusive(arr.length);
export const getRandValue = (arr) => arr[getRandIndex(arr)];

export const getDupes = (arr) => {
  const counts = {};
  const results = [];

  arr.forEach((item) => {
    counts[item] = (counts[item] || 0) + 1;

    if (counts[item] === 2) {
      results.push(item);
    }
  });

  return results;
};

export const getUniqueList = (arr, { disableSort } = {}) => {
  const res = Array.from(new Set(arr));
  if (!disableSort) {
    res.sort();
  }

  return res;
};

export const filledArray = (length, value = 0) => Array(length).fill(value);

export const randomizeContents = (array) => {
  let currentIndex = array.length;

  // While there remain elements to shuffle...
  while (currentIndex !== 0) {
    // Pick a remaining element...
    let randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex],
      array[currentIndex],
    ];
  }

  return array;
};

export const toggleInclusion = (
  arr,
  value,
  comparator = (v) => v === value
) => {
  if (find(arr, comparator)) {
    return filter(arr, (v) => !comparator(v));
  }

  return concat(arr || [], value);
};

export const compactAndJoin = (arr, joinStr) => {
  return compact(arr).join(joinStr)
}